
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CountryView,
} from '../models';
import {
    CountryViewFromJSON,
    CountryViewToJSON,
} from '../models';

/**
 * 
 */
export class ClientSignupCountriesApi extends runtime.BaseAPI {

    /**
     * Get the list of available countries
          */
    async getCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryView>>({
            path: `/signup-client/api/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryViewFromJSON);
        return response;
    }

    /**
     * Get the list of available countries
          */
    async getCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryView>> {
        const response = await this.getCountriesRaw(initOverrides);
        return response._data;
    }

}
